module.exports = __webpack_public_path__ + "static/media/EncodeSansCondensed-Regular.d105f2ce.ttf";